import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

//this component has details about the Moved date ,days until move , Arrival Time , Booking Number
const EstimateStatisticsSubComponent = (props) => {
  return(
      <li>
          <div className="estimate-arrival-time">
              <h6>{props.HeadingValue}</h6>
              <span>{props.Heading}</span>
          </div>
      </li>
  );
}
export default () => {
    let Estimate = useContext(RecordsManagementContext).CP_PageDetails.EstimateStatistics
    let Record = useContext(RecordsManagementContext)
    if (Record.CP_PageDetails.enrouteData) {
        const givenTime = Record.CP_PageDetails.enrouteData['arrived_at'];
        const currentTime = new Date(); // Get the current time
        const givenTimeDate = new Date(givenTime);
        const timeDifferenceInMs = currentTime - givenTimeDate;
        const minutes = timeDifferenceInMs / (1000 * 60)
        if(minutes <= 2){
            Record.setTruckArriveTime('00:00')
            Record.setOriginReached(true)
            setTimeout(() => {
                Record.sethideArrivedMessage(true);
                let el = document.getElementById('map-container-div')
                if(el) {
                    let currentPos = el.getBoundingClientRect()
                    for (var lx = 0, ly = 0;
                         el != null;
                         lx += el.offsetLeft, ly += el.offsetTop, el = el.offsetParent) ;
                    let pos = {x: lx, y: ly, height: currentPos.height, width: currentPos.width}
                    document.getElementById('map_canvas').style.cssText = `position:absolute;top:${pos.y}px;left:${pos.x}px;height:${pos.height}px; width:${pos.width}px;overflow:hidden`
                }
            }, 120000); // 120000ms = 1 minute
        }
    }
    return(
        <>
            { !Record.hideArrivedMessage && Record.CP_PageDetails.enrouteData && Record.TruckArriveTime != '' ?
        <div className="arriveMinutes">
            <br/>
            <h6>Your Movers {Record.OriginReached ? ' have arrived' : Record.TruckArriveTime}</h6>
        </div> : "" }
        <div className="estimate-time-mapping">
            <ul className="time-mapping-list pl-0 mb-0">
                <EstimateStatisticsSubComponent Heading={"Move Date"} HeadingValue={Estimate.MoveDate}/>
                <EstimateStatisticsSubComponent Heading={"Days Until Move"} HeadingValue={Estimate.DaysUntilMove}/>
                {Estimate.ArrivalTime ?
                    <EstimateStatisticsSubComponent Heading={"Arrival Timeframe"} HeadingValue={Estimate.ArrivalTime}/> : <></>}
                <EstimateStatisticsSubComponent Heading={"Booking No."} HeadingValue={Estimate.BookingNumber}/>
            </ul>
        </div>
        </>
    )
};